// extracted by mini-css-extract-plugin
export default {"container":"layout-inner_container__Ibz4y","children":"layout-inner_children__F9fem"};